import { handleFollowing } from 'APIs/utils';
import { useAppSelector } from 'app/hooks';
import UserPlus from 'assets/icons/ic_user_plus.svg';
import UserMinus from 'assets/icons/user-minus.svg';
import RoundedIconButton from 'components/atoms/Button/RoundedIconButton';
import { selectAuth } from 'features/auth/authSlice';
import { UserData } from 'interfaces/UserData.interface';
import React, { SetStateAction, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import SignInModal from './SignInModal';
import ChipWithData from 'components/atoms/Chip';

interface IUserProps {
  avatarSrc: string;
  username: string;
  userId: number;
  data: UserData;
  followed?: boolean;
  isPost?: boolean;
  invited?: boolean;
  setUser?: SetStateAction<any>;
}

const divStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '10px',
  margin: '10px',
  color: 'white',
  width: '100%',
  textTransform: 'capitalize',
} as React.CSSProperties;

const SingleUserRow: React.FC<IUserProps> = ({
  avatarSrc,
  username,
  data,
  userId,
  followed,
  isPost,
  invited,
  setUser,
}) => {
  const authState = useAppSelector(selectAuth);
  const [following, setFollowing] = useState<boolean>(
    followed || invited || false
  );
  const [invitedCreator, setInviteCreator] = useState<boolean>(false);
  const dispatch = useDispatch();

  return (
    <div style={divStyles}>
      <div style={divStyles}>
        <Link
          style={{ textDecoration: 'none' }}
          to={`/profile/${username}/feed`}
        >
          {' '}
          <ChipWithData username={username} avatar={data.avatar} />
        </Link>
      </div>
      {userId !== authState.id ? (
        <RoundedIconButton
          disabled={invitedCreator}
          icon={following ? UserMinus : UserPlus}
          text={
            isPost
              ? invited || invitedCreator
                ? 'Creator will be notified of this post'
                : 'Invite'
              : following
              ? 'Unfollow'
              : 'Follow'
          }
          style={{
            borderRadius: '15px',
            padding: '.5rem',
            display: 'flex',
            gap: '3px',
            width: '120px',
          }}
          onClick={async () => {
            if (isPost) {
              setUser(data);
              setInviteCreator(true);
            } else {
              await handleFollowing({
                authState,
                data,
                following,
                setFollowing,
                dispatch,
              });
            }
          }}
        />
      ) : !authState.id && userId !== authState.id ? (
        <SignInModal>
          <RoundedIconButton
            disabled={invitedCreator}
            icon={following ? UserMinus : UserPlus}
            text={
              isPost
                ? invited || invitedCreator
                  ? 'Creator will be notified of this post'
                  : 'Invite'
                : following
                ? 'Unfollow'
                : 'Follow'
            }
            width="40px"
            height="15px"
            style={{
              borderRadius: '15px',
              padding: '.5rem',
              display: 'flex',
              gap: '1px',
            }}
          />
        </SignInModal>
      ) : (
        <></>
      )}
    </div>
  );
};

export default SingleUserRow;
